import styled from "styled-components";

export const SearchResultItemDefaultBox = styled.li`
    list-style-type: none;
    
    &:hover {
      background-color: ${props => props.theme.colors.background};
    }
`;